import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Cookie, X } from "lucide-react";
import { OPEN_PREFERENCES_EVENT, readConsent, saveConsent } from "@/lib/consent";
import { EASE } from "@/lib/motion";

const btn = "h-12 flex-1 rounded-full px-5 text-[16px] font-medium transition-colors";

export const CookieBanner = () => {
  const [open, setOpen] = useState(() => readConsent() === null);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(OPEN_PREFERENCES_EVENT, show);
    return () => window.removeEventListener(OPEN_PREFERENCES_EVENT, show);
  }, []);

  const choose = (analytics) => {
    saveConsent(analytics);
    setOpen(false);
  };

  if (!open) return null;
  return (
    <motion.div
      role="dialog"
      aria-labelledby="cookie-banner-title"
      initial={{ y: 24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: EASE }}
      className="fixed inset-x-3 bottom-3 z-[60] rounded-3xl border border-copper/30 bg-cream p-6 shadow-[0_24px_60px_-20px_rgba(15,30,51,0.45)] sm:inset-x-auto sm:left-6 sm:bottom-6 sm:max-w-md"
      data-testid="cookie-banner"
    >
      <button type="button" onClick={() => choose(false)} aria-label="Chiudi e rifiuta i cookie non necessari" data-testid="cookie-close" className="absolute right-4 top-4 grid h-10 w-10 place-items-center rounded-full text-navy transition-colors hover:bg-sand">
        <X className="h-5 w-5" />
      </button>
      <p id="cookie-banner-title" className="flex items-center gap-3 pr-10 font-display text-2xl text-navy">
        <Cookie className="h-5 w-5 shrink-0 text-copper" strokeWidth={1.5} /> La tua privacy
      </p>
      <p className="mt-3 text-[15px] leading-relaxed text-slate2">
        Usiamo strumenti tecnici necessari al funzionamento del sito e, solo se lo accetti, statistiche per capire come migliorarlo. Puoi cambiare idea quando vuoi da "Preferenze cookie" in fondo alla pagina.{" "}
        <Link to="/cookie" className="font-medium text-navy underline underline-offset-4" data-testid="cookie-policy-link">Leggi la cookie policy</Link>
      </p>
      <div className="mt-5 flex gap-3">
        <button type="button" onClick={() => choose(false)} data-testid="cookie-reject" className={`${btn} border border-navy text-navy hover:bg-sand`}>Rifiuta</button>
        <button type="button" onClick={() => choose(true)} data-testid="cookie-accept" className={`${btn} border border-navy bg-navy text-ivory hover:bg-navy-700`}>Accetta</button>
      </div>
    </motion.div>
  );
};
